import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button'
import FormLabel  from '@material-ui/core/FormLabel';
import Alert from '@material-ui/lab/Alert';
import axios from 'axios';

const ChangePasswordPage = ({ viewerObj, setViewerObj }) => {

  const API_URL = "https://310nwnmom8.execute-api.us-west-2.amazonaws.com";
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // update the password state based on which input tag is being used
  const onChange = ({ target }) => {
    // reset error and load state if theres an active error message
    if(errorMessage) { 
      setErrorMessage('');
      setIsLoading(false);
    }

    const { name, value } = target;
    name === "new password" ? setNewPassword(value) : setConfirmNewPassword(value)
  }
  
  const submitNewPassword = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    setSuccessMessage("");
    if(!newPassword) return setErrorMessage('input a valid password');
    if(newPassword !== confirmNewPassword) return setErrorMessage('passwords do not match');
     
    const { error } = await axios.post(`${API_URL}/update-password`, 
    { 
      viewerId: viewerObj._id, 
      newPassword 
    });

    if(error) setErrorMessage(error);

    // update the state of the viewer object with the updated password
    setViewerObj({ ...viewerObj, password: newPassword });
    
    // update the password in local storage to sustain login
    localStorage.setItem('password', newPassword);

    setSuccessMessage('Password updated successfully');

    // reset all state values back to default values
    setNewPassword('');
    setConfirmNewPassword('');
    setTimeout(() => setSuccessMessage(''),5000);
    setIsLoading(false);
  }

  return (
    <>
      <form noValidate autoComplete="off" onSubmit={submitNewPassword}>
        {errorMessage && <Alert 
                          variant="filled" 
                          severity="error"
                          >
                            {errorMessage}
                          </Alert>}
        {successMessage && <Alert 
                          variant="filled" 
                          severity="success"
                          >
                            {successMessage}
                          </Alert>}
        <FormLabel>New Password</FormLabel>
        <TextField
          fullWidth  
          type='password'
          name="new password"
          value={newPassword}
          onChange={onChange}
          variant="outlined" />
        <FormLabel>Confirm New Password</FormLabel>
        <TextField
          fullWidth  
          type='password'
          name="confirm new password"
          value={confirmNewPassword}
          onChange={onChange}
          variant="outlined" />
        <Button 
          type="submit"
          margin="normal"
          disabled={isLoading}
          variant="contained"
          color="primary"
        >
          Submit
        </Button>
      </form>
    </>
  )
}

export default ChangePasswordPage